export const INPUT_BORDER = 1

export const SINGLE_DATE = 'Choose a day'
